export enum RecordingPreferenceId {
	VIDEO = 'VIDEO',
	AUDIO = 'AUDIO',
}
